export default "__VITE_ASSET__DXVFZjAS__"